/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
import accessGroupColumns from './columns/accessGroup';

const components = {
    accessGroupColumns
}

export { components }